import React from 'react'
import { Link, graphql } from 'gatsby'
import Footer from '@berlitz/footer'
import Container from '../Container'
import styled from 'styled-components'
import Logo from '@berlitz/logo'
import { NavLink } from '@berlitz/footer/lib/Footer.style'
import { formatTelHref } from '@berlitz/max-utils/lib/formatTelHref'
import cleanDeep from 'clean-deep'

const getLinks = items => {
  if (!items) return
  const links = items.map((item, index) => (
    <a
      key={index}
      href={item.links.url}
      target={item.links.target || '_self'}
      rel="noopener noreferrer"
    >
      {item.custom_link_title || item.links.document?.data.title}
    </a>
  ))
  return links
}

const FooterWrapper = styled.div`
  padding: ${({ theme }) => theme.space.xxxl} 0;
`

const PartnerLogo = styled.img`
  margin: 0 auto;
  max-width: 100%;
  width: ${({ theme }) => theme.layout.xxl};
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin: 0;
  }
`
const PhoneLink = styled(NavLink)`
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`
const phoneLink = phoneNumbers => {
  const phone = phoneNumbers[0]?.phone_number?.document?.data?.phone_number
  return phone ? (
    <a data-key="footer__phone-link" href={`${formatTelHref(phone)}`}>
      {phone}
    </a>
  ) : null
}

const multiPhoneLink = phoneNumbers =>
  phoneNumbers?.length > 1
    ? phoneNumbers?.map(key => {
        const {
          phone_number: {
            document: {
              data: { phone_number, title },
            },
          },
        } = key
        if (!phone_number || !title) return null

        return (
          <PhoneLink key={`footer-phone-${phone_number}`}>
            <a href={`${formatTelHref(phone_number)}`}>
              {title}: {phone_number}
            </a>
          </PhoneLink>
        )
      })
    : null
const FooterContainer = ({
  homeUrl,
  columns,
  partnerLogo,
  phoneNumbers,
  socialLinks,
}) => {
  return (
    columns?.length > 0 && (
      <Container>
        <FooterWrapper>
          <Footer
            logo={
              <Link to={homeUrl} data-key="footer__logo-home-link" rel="home">
                <Logo type="secondary" />
              </Link>
            }
            socialLinks={socialLinks}
            phone={
              multiPhoneLink(cleanDeep(phoneNumbers)) || phoneLink(phoneNumbers)
            }
            columnFourLinks={getLinks(columns[3]?.items)}
            columnFourTitle={columns[3]?.primary.column_title}
            columnThreeLinks={getLinks(columns[2]?.items)}
            columnThreeTitle={columns[2]?.primary.column_title}
            columnTwoLinks={getLinks(columns[1]?.items)}
            columnTwoTitle={columns[1]?.primary.column_title}
            columnOneLinks={getLinks(columns[0]?.items)}
            columnOneTitle={columns[0]?.primary.column_title}
            columnOneLogo={<PartnerLogo src={partnerLogo} />}
          />
        </FooterWrapper>
      </Container>
    )
  )
}

export const query = graphql`
  fragment Columns on PrismicFooterDataBodyFooterColumn {
    slice_type
    slice_label
    items {
      custom_link_title
      links {
        url
        target
        document {
          ... on PrismicPage {
            data {
              title
            }
          }
        }
      }
    }
    primary {
      column_title
    }
  }
  fragment FooterPhoneNumbers on PrismicFooterDataPhoneNumbers {
    phone_number {
      document {
        ... on PrismicPhoneNumbers {
          id
          data {
            title
            phone_number
            phone_description {
              html
            }
            link_format
            external_link_title
            external_link_icon
          }
        }
      }
    }
  }
`

export default FooterContainer
